import { setGeofenceInteractionTypes } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { GIType } from '@customer/store/apis/interactionsApi';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

// Remove "Unknown" from the list
const GI_TYPES: GIType[] = Object.values(GIType).slice(1);

const useGeofenceInteractionTypeOptions = (): DropdownItemProps<GIType>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return GI_TYPES.map((value: GIType) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`gi.name.${value}`),
      };
    });
  }, [t]);
};

export const GeofenceInteractionTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<GIType>
      filterName="geofenceInteractionTypes"
      label={label ?? t('InteractionType')}
      action={setGeofenceInteractionTypes}
      elementRef={elementRef}
      useItemsHook={useGeofenceInteractionTypeOptions}
    />
  );
};

export default GeofenceInteractionTypesFilter;
